import {
  GET_PARTNER_ACCOUNT,
  GET_PARTNER_ACCOUNT_SUCCESS,
  GET_PARTNER_ACCOUNT_FAILURE,
} from "../actionTypes";

export const getPartnerAccountData = (payload) => ({
  type: GET_PARTNER_ACCOUNT,
  payload,
});

export const getPartnerAccountDataSuccess = (payload) => ({
  type: GET_PARTNER_ACCOUNT_SUCCESS,
  payload,
});

export const getPartnerAccountDataFailure = () => ({
  type: GET_PARTNER_ACCOUNT_FAILURE,
});
